
import styles from "./styles.module.scss";

export default function ResultNotFound({message="Nenhum resultado encontrado!", style}) {
  return <span className={styles.message} style={{...style}}>{message}</span>
}